import { QRCode } from "react-qrcode-logo"


export const QrGenerator = ({barcode}) => {

    return (
        <QRCode value={barcode} 
        logoImage="lc-logo.png"
         size={150} removeQrCodeBehindLogo={true} logoPadding={0} logoWidth={35} logoHeight={35} />
    )
}